var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.AppPage,{attrs:{"title":"Recent Uploads","subtitle":"View the latest files uploaded by your team.","icon":['far', 'clock']}},[_c(_setup.SmeAlert,{attrs:{"level":"warning"}},[_vm._v("Uploaded files may take up to 5 minutes to appear in the list.")]),_c(_setup.RecentUploadsList)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }